import { render } from "./DefectivePartsSection.vue?vue&type=template&id=f568976e&scoped=true&ts=true"
import script from "./DefectivePartsSection.vue?vue&type=script&lang=ts"
export * from "./DefectivePartsSection.vue?vue&type=script&lang=ts"

import "./DefectivePartsSection.vue?vue&type=style&index=0&id=f568976e&lang=scss&scoped=true"

import exportComponent from "/home/production/domains/monteur.waterluxe.nl/monteur-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f568976e"]])

export default __exports__